module.exports = __webpack_public_path__ + "img/vote.7ed99a6c.png";